<template>
  <div class="candidates-filters">
    <div class="candidates-filters__primary">
      <div class="relative candidates-filters__search">
        <i class="pi pi-search absolute left-3 top-1/2 -translate-y-1/2 text-gray-400" />
        <InputText
          :model-value="search"
          placeholder="Search name, ID, field, old/new value, user, note…"
          class="pl-10 w-full"
          @update:model-value="onSearchInput"
        />
      </div>

      <Select
        :model-value="refType || null"
        :options="refTypeOptions"
        option-label="label"
        option-value="value"
        placeholder="All record types"
        show-clear
        class="candidates-filters__field w-full"
        @update:model-value="onRefTypeChange"
      />

      <DatePicker
        input-id="history-date-from"
        :model-value="dateFromModel"
        date-format="yy-mm-dd"
        show-icon
        placeholder="From"
        class="candidates-filters__field w-full"
        aria-label="From date"
        @update:model-value="onDateFrom"
      />
      <DatePicker
        input-id="history-date-to"
        :model-value="dateToModel"
        date-format="yy-mm-dd"
        show-icon
        placeholder="To"
        class="candidates-filters__field w-full"
        aria-label="To date"
        @update:model-value="onDateTo"
      />

      <Button
        type="button"
        label="Clear"
        severity="secondary"
        text
        :disabled="!hasActiveFilters"
        @click="$emit('clear')"
      />
    </div>
  </div>
</template>

<script setup>
import { computed } from 'vue';
import InputText from 'primevue/inputtext';
import Select from 'primevue/select';
import Button from 'primevue/button';
import DatePicker from 'primevue/datepicker';
import { parseDateSafe, toYMD } from '@/utils/dateHelper';

defineOptions({ name: 'HistoryFiltersBar' });

const props = defineProps({
  search: { type: String, default: '' },
  refType: { type: String, default: '' },
  dateFrom: { type: String, default: '' },
  dateTo: { type: String, default: '' }
});

const emit = defineEmits([
  'update:search',
  'update:refType',
  'update:dateFrom',
  'update:dateTo',
  'search-debounced',
  'filter-change',
  'clear'
]);

const refTypeOptions = [
  { label: 'Lead', value: 'lead' },
  { label: 'In Progress', value: 'inprogress' },
  { label: 'Driver', value: 'driver' }
];

const dateFromModel = computed(() => parseDateSafe(props.dateFrom));
const dateToModel = computed(() => parseDateSafe(props.dateTo));

const hasActiveFilters = computed(
  () => !!(props.search || props.refType || props.dateFrom || props.dateTo)
);

let searchTimer = null;
function onSearchInput(value) {
  emit('update:search', value ?? '');
  clearTimeout(searchTimer);
  searchTimer = setTimeout(() => emit('search-debounced'), 300);
}

function onRefTypeChange(value) {
  emit('update:refType', value || '');
  emit('filter-change');
}

function onDateFrom(value) {
  emit('update:dateFrom', toYMD(value) || '');
  emit('filter-change');
}

function onDateTo(value) {
  emit('update:dateTo', toYMD(value) || '');
  emit('filter-change');
}
</script>
